import React from "react";
import { withRouter } from "react-router-dom";
import { Heading } from "../Typography";
import { Add, Grid, Logout } from "../Icons";

function Wrapper(props) {
  const isOnAdd = window.location.pathname.match("/add");
  const isOnProductList =
    window.location.pathname.match("/products") && !isOnAdd;
  return (
    <div
      style={{
        height: "inherit",
        padding: "16px",
        overflowY: "auto",
        paddingBottom: "64px",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Heading>{window.location.pathname.replaceAll("/", ">")}</Heading>
        <button
          className="icon"
          onClick={() => {
            try {
              window.localStorage.clear();
            } catch (error) {
              console.log(error);
            }
          }}
        >
          <Logout />
        </button>
      </div>
      {props.children}
      <footer>
        <button className="icon" onClick={() => props.history.push("/")}>
          <Grid />
        </button>
        {isOnProductList ? (
          <button
            className="icon"
            onClick={() => props.history.push("/articles/add")}
          >
            L
          </button>
        ) : null}

        {isOnAdd ? null : (
          <button
            className="icon"
            onClick={() =>
              props.history.push(`${window.location.pathname}/add`)
            }
          >
            <Add />
          </button>
        )}
      </footer>
    </div>
  );
}
export default withRouter(Wrapper);
